<template lang="html">
  <div class="container">
    <h2 class="title">
      Search for our nearest certified vendor
    </h2>
    <div class="addressInput">
      <input
        id="address"
        type="text"
      >
      <h3 id="textStyle">
        Or
      </h3>
      <button
        id="locationButton"
        class="user-location btn btn-custom theme-color"
      >
        Use My Location
      </button>
      <p class="error-message">
        Geolocation is not supported by this browser.
      </p>
    </div>

    <div id="map" />
  </div>
</template>

<script>
/* global google */

export default {
  name: 'MapComp',
  data: () => ({
    selectedLocation: '',
    markerCollection: [
      {
        location: { lat: 49.324547, lng: -123.12178 },
        pinImage: 'North Van Mitsubishi logo.jpg',
      },
      {
        location: { lat: 49.323755, lng: -123.117163 },
        pinImage: 'north van napa logo.jpg',
      },
    ],
    map: null,
  }),
  mounted() {
    // let googleMap = document.createElement('script')
    // recaptchaScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBHOfYbapBztBpBzucBw7GtBgR5nza-wOw&region=CA&libraries=places,geometry" async')
    // document.head.appendChild(googleMap)
    // },
    window.addEventListener('load', () => {
      if (google !== undefined) {
        initialize()

        document.getElementsByClassName('user-location')[0].addEventListener('click', () => {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getUserLocation, processLocationError)
          } else {
            document.getElementsByClassName('error-message')[0].classList.add('show')
          }
        })
      }
    })

    function getUserLocation(position) {
      this.selectedLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }
      populateMap()
    }

    function processLocationError(error) {
      const errorElement = document.getElementsByClassName('error-message')[0]
      errorElement.innerHTML = error.message
      errorElement.classList.add('show')
    }

    function initialize() {
      const addressInput = document.getElementById('address')
      const restrictSearchConfig = {
        componentRestrictions: { country: 'ca' },
      }

      const autocomplete = new google.maps.places.Autocomplete(addressInput, restrictSearchConfig)
      const addressInputEventListener = () => {
        autocomplete.setFields(['geometry.location'])
        autocomplete.addListener('place_changed', fetchPlaceDetails)
      }

      addressInput.on = addressInputEventListener
      addressInput.onfocus = addressInputEventListener
    }

    function fetchPlaceDetails() {
      this.selectedLocation = this.getPlace().geometry.location
      populateMap()
    }

    function populateMap() {
      this.map = new google.maps.Map(document.getElementById('map'), {
        zoom: 8,
        center: this.selectedLocation,
      })
      populateMarkers(this.map)
    }

    function populateMarkers(map) {
      this.markerCollection.map(function(markerObj, i) {
        const customIcon = new google.maps.MarkerImage(
          '../assets/images/autoshoplogo/' + markerObj.pinImage,
          new google.maps.Size(35, 35),
          new google.maps.Point(0, 0),
          new google.maps.Point(17, 34),
          new google.maps.Size(35, 35)
        )

        let marker
        if (markerObj.pinImage) {
          marker = new google.maps.Marker({
            position: markerObj.location,
            icon: customIcon,
            map: map,
          })
        } else {
          marker = new google.maps.Marker({
            position: markerObj.location,
            map: map,
          })
        }

        marker.addListener('click', function() {
          const bounds = new google.maps.LatLngBounds()
          bounds.extend(markerObj.location)
          map.fitBounds(bounds)
          map.setZoom(14)
        })
      })
    }
  },
}
</script>

<style lang="css" scoped>
  .container {
    padding: 1rem;
    text-align: center;
  }

  .title {
    margin-top: 4rem;
    width: 100%;
  }

  .addressInput {
    margin-top: 4rem;

  }

  #address {
    width: 25rem;
    padding: 0.5rem;

  }

  #map {
    height: 60vh;
    margin-top: 2rem;
  }

  #locationButton {
    text-align: center;
  }

  .user-location {
    padding: 0.5rem;
    cursor: pointer;
  }

  .error-message {
    display: none;
  }

  #textStyle {
    display: inline-block;
    margin: 0 3rem;
  }

  .error-message.show {
    display: block;
    color: #ff0000;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/mapcomp.vue